/* global System */
// register component(s) with react habitat

export default { Sortiment: () => System.import('./index') }
